<!--
 * @Description: 备课 列表页
 * @Author: ZSC
 * @Date: 2023-04-23 16:37:34.773
 * @LastEditors: PF
 * @LastEditTime: 2024-01-19 20:09:33
-->
<template>
  <div>
    <el-dialog class="wp80 hp90" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">备课</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-select placeholder="学期" v-model="dataGrid.parms.xqid" clearable filterable @change="bindTable()">
                  <el-option v-for="item in xqData" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="学期" prop="xqmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="周次" prop="zc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" >
                <template #default="scope">
                  <span>第{{scope.row.zc}}周</span>
                </template>
              </el-table-column>
              <el-table-column label="班级" prop="xzbmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="课程" prop="kcmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="教学单元" prop="jxdybt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="教学内容" prop="jxnrbt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="提交时间" prop="tjsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="120" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" v-if="scope.row.zt.value==1" @click="tijiao(scope.row.id)">提交</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <el-dialog class="w600 h430" v-model="dialogFormVisible" title="批评与建议">
    <el-input v-model="ppyjy" :rows="5" type="textarea" />
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="baoCunClick()">
          保存
        </el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </span>
    </template>
  </el-dialog>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from 'vue'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import { loadList, loadSelect, actionPatch, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import detail from '@/components/home/changguishiwu/jiaoshi/jiaoxuesheji/detailbeike.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const dqid = ref() // 当前id
const dqlx = ref() // 当前类型
const ppyjy = ref() // 批评与建议
const zcData = ref([])
const getzclist = () => {
  loadSelect({
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: zcData,
    parms: { xqid: dataGrid.value.parms.xqid },
    loadSuccess: function (res) {
      const zcs = []
      zcData.value = []
      res.data.forEach((element) => {
        if (zcs.indexOf(element.zc) === -1) {
          zcs.push(element.zc)
          zcData.value.push(element)
        }
      })
      dataGrid.value.parms.zcid = zcData.value[0].zc
    }
  })
}
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'tjsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})

const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/jiaowu/jiaowubeike/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openDetail = ref(false)
const openList = ref(false)
const jssjztData = ref()
const xqData = ref()
watch(
  () => props.open,
  () => {
    if (props.open === 'wodebeike') {
      openList.value = true
      loadSelect({ url: '/api/v2/jiaowu/jiaowujiaoxuesheji/jiaoxueshejizhuangtai', data: jssjztData, order: 'sx', sort: 'asc' })
      loadSelect({
        url: '/api/v2/pdp/xueqi/list',
        data: xqData,
        order: 'sx',
        sort: 'asc',
        loadSuccess: function (res) {
          res.data.forEach((element) => {
            if (element.sfdqxq === true) {
              dataGrid.value.parms.xqid = element.id
              bindTable()
              getzclist()
            }
          })
        }
      })
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

// 提交
const tijiao = (val) => {
  actionPatch({ url: '/api/v2/jiaowu/jiaowubeike/beiketijiao', data: { id: val } }).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
const dialogFormVisible = ref(false)
// 是否合格
const baoCunClick = () => {
  dialogFormVisible.value = false
  let ids = []
  if (dqid.value) {
    ids.push(dqid.value)
  } else {
    ids = multipleSelection.value
  }
  const obj = {
    menuId: sessionStorage.getItem('menuId'), // 菜单ID
    zt: dqlx.value,
    ppyjy: ppyjy.value,
    ids
  }
  const options = {
    url: '/api/v2/jiaowu/jiaowujiaoxuesheji/updateHS',
    data: obj
  } // [url]接口地址 [data]
  actionPatch(options).then((res) => {
    if (res.code === 200) {
      bindTable()
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
</script>
